import { flow } from 'lodash';

import { NAME } from './drawerMenuMobile.constant';

import { selectState as selectStateDrawer } from '../drawers.selector';

const selectStateKey = (state) => state[NAME];
const selectVisibleKey = (state) => state.visible;
const selectPayloadKey = (state) => state.payload;

export const selectState = flow(selectStateDrawer, selectStateKey);
export const selectVisible = flow(selectState, selectVisibleKey);
export const selectPayload = flow(selectState, selectPayloadKey);
